import { TextField, MenuItem } from "@mui/material";
import { useField, useFormikContext } from "formik";

export default function SubjectSelectComponent({
  name,
  options,
  setSubjectCode,
  ...otherProps
}) {
  const { setFieldValue } = useFormikContext();
  const [field, metaData] = useField(name);

  const handleChange = (e) => {
    setFieldValue(name, e.target.value);
  };
  const selectConfig = {
    ...field,
    ...otherProps,
    select: true,
    variant: "outlined",
    fullWidth: false,
    onChange: handleChange,
  };

  if (metaData && metaData.touched && metaData.error) {
    selectConfig.error = true;
    selectConfig.helperText = metaData.error;
  }
  return (
    <TextField {...selectConfig}>
      {options &&
        options?.map((option, index) => {
          return (
            <MenuItem
              value={option.subjectName}
              key={index}
              onClick={() => {
                setSubjectCode(option.subjectCode);
              }}
            >
              {option.subjectName}
            </MenuItem>
          );
        })}
    </TextField>
  );
}
